import React from "react";
import { v4 as uuidv4 } from "uuid";
import Button from "@mui/material/Button";
import { Paper } from "@mui/material";
import cloud from "../../assets/db_images/cloud-data.png";
import legacy from "../../assets/db_images/legacy.png";
import cross from "../../assets/db_images/cross-platform.png";
import scla from "../../assets/cloud_migration/scalability.png";
import security from "../../assets/cloud_migration/security.png";

const CloudMigrationServices = () => {
  let featureList = [
    {
      id: uuidv4(),
      title: "Strategic Planning",
      image: cloud,
      description: `Strategic planning for Cloud Migration Services involves meticulously
            mapping out the journey from on-premises or existing cloud
            environments to a new cloud infrastructure, ensuring a seamless and
            efficient transition. Our approach combines a deep understanding of
            your current IT landscape with a focus on aligning cloud migration
            with your overarching business objectives. We conduct a thorough
            analysis of your existing IT infrastructure, applications, and data to
            identify dependencies and opportunities for improvement. Our team
            assesses the compatibility of workloads with the selected cloud
            environment, laying the groundwork for a successful migration.`,
    },
    {
      id: uuidv4(),
      title: "Cost Optimization",
      image: legacy,
      description: `In our Cost Optimization for Cloud Migration Services, we specialize
            in maximizing the efficiency and value of your cloud investment. Our
            strategic approach involves a meticulous analysis of your cloud usage,
            ensuring that you not only achieve seamless migration but also reap
            the most cost-effective benefits from your chosen cloud environment.
            Our services include continuous monitoring of your cloud
            infrastructure, allowing us to identify and rectify performance
            bottlenecks and cost inefficiencies promptly. We provide ongoing
            support to ensure that your cloud environment remains optimized as
            your business evolves.`,
    },
    {
      id: uuidv4(),
      title: "Seamless Execution",
      image: cross,
      description: `In our Cloud Migration Services, we specialize in delivering a
            seamless execution that ensures a smooth and efficient transition to
            the cloud. Our approach is focused on minimizing disruptions,
            optimizing performance, and guaranteeing the successful relocation of
            your digital assets. Understanding that your business objectives are
            paramount, we align our migration strategy with your specific goals.
            With our Seamless Execution in Cloud Migration Services, we guarantee
            a hassle-free transition to the cloud, allowing you to focus on your
            core business activities while we handle the intricacies of migration
            with precision and expertise.`,
    },
    {
      id: uuidv4(),
      title: "Scalability And Flexibility",
      image: scla,
      description: `In our Cloud Migration Services, we prioritize scalability and
            flexibility to empower your business with dynamic and adaptable IT
            infrastructure. Our approach is tailored to seamlessly transition your
            operations to the cloud, ensuring that your digital environment can
            effortlessly scale to meet evolving demands and changes in your
            business landscape. Our services include strategic planning to
            accommodate your business growth. We anticipate future scalability
            needs and plan accordingly to support your expanding operations`,
    },
    {
      id: uuidv4(),
      title: "Security Assurance",
      image: security,
      description: `In our Cloud Migration Services, security assurance is at the
              forefront of our approach, ensuring that your transition to the cloud
              is not only seamless but also fortified with robust measures to
              safeguard your digital assets. Our commitment is to provide a secure
              migration environment, adhering to the highest industry standards and
              best practices. With our Security Assurance in Cloud Migration
              Services, we provide you with the confidence that your migration
              journey is fortified by state-of-the-art security measures. Your
              digital assets remain protected, and your operations stay resilient in
              the face of cybersecurity challenges`,
    },
  ];

  return (
    <div id="solutions">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Services we Provide
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 grid-rows-2 px-3 sm:px-20 mt-10 gap-3 flex-col sm:flex-row sm:flex-wrap">
        {featureList.map((item) => (
          <div
            key={item.id}
            class="w-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md"
          >
            <div class="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              {item.title}
            </div>
            <div class="col-span-2 rounded-md">{item.description}</div>
            <div>
            <Button variant="outlined" href="#contact">Let's Connect</Button>
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CloudMigrationServices;
